import PodonexVersionChannelEnum from '@/domains/settings/typescript/enums/PodonexVersionChannelEnum';
import type PodonexConfigurationDTOInterface from '@/domains/settings/typescript/interfaces/PodonexConfigurationDTOInterface';
import type PodonexConfigurationInterface from '@/domains/settings/typescript/interfaces/PodonexConfigurationInterface';

export default function transformDTOtoPodonexConfiguration(
    configuration: PodonexConfigurationDTOInterface,
): PodonexConfigurationInterface {
    return {
        '@id': configuration['@id'],
        id: configuration.id,
        scannerId: configuration.scanner,
        lightSensibility: configuration.lightSensibility,
        sobelThreshold: configuration.threshold,
        cleaningSteps: configuration.steps,

        brightness: configuration.brightness,
        contrast: configuration.contrast,
        userId: configuration.owner,
        macBrightness: configuration.macBrightness,
        macContrast: configuration.macContrast,

        negativeBrightness: configuration.negativeBrightness,
        negativeContrast: configuration.negativeContrast,
        negativeMacBrightness: configuration.negativeMacBrightness,
        negativeMacContrast: configuration.negativeMacContrast,

        podonexVersionChannel: configuration.podonexVersionChannel ?? PodonexVersionChannelEnum.STABLE,
    };
}
